<template>
	<div class="child-container cash">
		<div class="surf-content-section">
			<div class="chart-header">
				<div class="chart-header-comparisons">
					<ComparisonSelections
						:activeDate.sync="activeDate"
						:activePeriod.sync="activePeriod"
						@dateChange="initChartData"
						@periodChange="getCashData"
					/>
				</div>
			</div>
			<div class="chart-wrapper">
				<LineBarChart v-bind="chartData" class="chart-wrapper-box" :isMobile="mobile" />
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import LineBarChart from '@/rebuild/components/charts/bar/lineBar.vue';
import ComparisonSelections from './ComparisonSelections.vue';
import { useFinanceCommon } from '../useFinanceCommon';
import { useFinanceData } from '../useFinanceData';
import { convertPX } from '@/utils/echarts';


const props = defineProps({
	mobile: {
		type: Boolean,
		default: false
	}
});

const { loadData, getChartDataFunc } = useFinanceData();
const { activeDate, activePeriod, sliceDataByDate } = useFinanceCommon();

const resData = ref([]);
const getChatOriginData = computed(() => (resData.value || []).sort((a, b) => a.year - b.year));

async function refresh() {
	await getCashData();
}
onMounted(() => {
	activeDate.value = 5;
	refresh();
});

async function getCashData() {
	const res = await loadData('cash_flow_statement', activePeriod.value);
	resData.value = res.data;
	initChartData();
}

const chartData = ref({ seriesData: [] });
function initChartData() {
	const dataList = sliceDataByDate(getChatOriginData.value, activeDate.value);
	const fn = getChartDataFunc('cash_flow_statement');
	const _chartData = fn(null, dataList);

	_chartData.seriesData.forEach(item => {
		item.data = item.data.map(dataItem => {
			return {
				value: dataItem[1],
				name: dataItem[0], // 保留 x 轴数据
				itemStyle: {
					borderRadius:
						dataItem[1] >= 0 ? [convertPX(4), convertPX(4), 0, 0] : [0, 0, convertPX(4), convertPX(4)]
				}
			};
		});
	});
	chartData.value = _chartData || { seriesData: [] };
	if (props.mobile) {
		chartData.value.chartOptions = {
			legend: { show: false },
			yAxis: [
				{
					axisLabel: {
						show: true
					}
				}
			]
		};
		chartData.value.legends = chartData.value.seriesData.map(item => item.name);
	}
}
</script>

<style lang="less" scoped>
.mt20 {
	margin-top: 20px;
}
.chart-header {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	.chart-header-title {
		color: var(--surf-inverse-color);
		font-size: 16px;
		font-weight: 500;
		line-height: 24px; /* 150% */
	}
}
.chart-wrapper {
	.chart-wrapper-box {
		width: 100%;
		height: 256px;
	}
}
.chart-header-comparisons {
	flex-shrink: 0;
}
</style>
